// 챌린지 이미지 유틸리티 함수들

// 사용 가능한 이미지 목록
const CHALLENGE_IMAGES = [
  'challenge1.png',
  'challenge2.png',
  'challenge3.png',
  'challenge4.png',
  'challenge5.png',
  'challenge6.png',
  'challenge7.png'
];

/**
 * 챌린지 ID를 기반으로 일관성 있게 이미지를 선택하는 함수
 * 같은 챌린지 ID에 대해서는 항상 같은 이미지를 반환
 * @param {string|number} challengeId - 챌린지 ID
 * @returns {string} 이미지 파일명
 */
export const getChallengeImage = (challengeId) => {
  if (!challengeId) {
    return CHALLENGE_IMAGES[0]; // 기본 이미지
  }

  // 챌린지 ID를 문자열로 변환하고 해시값 생성
  const idString = String(challengeId);
  let hash = 0;

  for (let i = 0; i < idString.length; i++) {
    const char = idString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // 32bit 정수로 변환
  }

  // 항상 양수가 되도록 처리
  const positiveHash = Math.abs(hash);

  // 이미지 배열 인덱스로 변환
  const imageIndex = positiveHash % CHALLENGE_IMAGES.length;

  return CHALLENGE_IMAGES[imageIndex];
};

/**
 * 챌린지 이미지의 전체 경로를 반환하는 함수
 * @param {string|number} challengeId - 챌린지 ID
 * @returns {string} 이미지의 전체 경로
 */
export const getChallengeImagePath = (challengeId) => {
  const imageName = getChallengeImage(challengeId);
  // process.env.PUBLIC_URL을 사용하여 절대 경로 생성 (빈 문자열이면 상대 경로로 처리)
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}/images/quiz-challenges/${imageName}`;
};

/**
 * 이미지 프리로드를 위한 함수
 * @param {Array} challengeIds - 프리로드할 챌린지 ID 배열
 */
export const preloadChallengeImages = (challengeIds) => {
  if (!challengeIds || challengeIds.length === 0) return;

  challengeIds.forEach(challengeId => {
    const img = new Image();
    img.src = getChallengeImagePath(challengeId);
  });
};

// 개발용: 챌린지 ID와 선택될 이미지를 미리 확인하는 함수
export const debugChallengeImageMapping = (challengeIds) => {
  if (!Array.isArray(challengeIds)) return {};

  return challengeIds.reduce((mapping, challengeId) => {
    mapping[challengeId] = getChallengeImage(challengeId);
    return mapping;
  }, {});
};